import { useState, useEffect } from "react";
import { useGetData } from "../../Network/useGetQueryData";

interface UseDynamicSelectOptionsProps {
  url: string;
  queryKey: string[];
  params?: Record<string, any>;
  shouldFetch?: boolean; // Control API calls dynamically
}

export const useDynamicSelectOptions = ({
  url,
  queryKey,
  params = {},
  shouldFetch = true, // Default is true
}: UseDynamicSelectOptionsProps) => {
  const [options, setOptions] = useState<any[]>([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);

  const { data, isLoading } = useGetData<{
    data: { items: any[]; count: number };
  }>({
    queryKey: [...queryKey, offset, limit],
    url,
    params: shouldFetch ? { ...params, offset, limit } : undefined,
    options: {
      enabled: shouldFetch,
      queryKey: [...queryKey, offset, limit],
    },
  });

  useEffect(() => {
    if (data?.data?.items) {
      setOptions((prev) =>
        offset === 0 ? data.data.items : [...prev, ...data.data.items]
      );
    }
  }, [data]);

  const fetchNextPage = () => {
    if (data?.data?.items?.length < data.data.count) {
      setOffset((prev) => prev + limit);
    }
  };

  return { options, isLoading, fetchNextPage };
};
